import axios from 'axios';

export default function putCompanyTags({ uuid, tags }) {
  return new Promise((resolve, reject) => axios
    .put(`/account/system-admin/api/v1/company/${uuid}/tag`, { tag: tags })
    .then((response) => resolve(response))
    .catch((error) => reject(error.message)));
}
